import App from 'app/app.js';
import 'app/store/JobStore.js';
import 'app/store/ContentStore.js';

function CheckoutService($http, JobStore, ContentStore, $q) {
  this.generateToken = function () {
    return $http.get('checkout/getAuthorization/' + JobStore.getJob().paymentAccount + '?rnd=' + this.getCurrentTime());
  };

  this.getCurrentTime = function () {
    return new Date().getTime();
  };

  this.processSccSubmission = function (payment) {
    return this.generateToken().then(function (response) {
      payment.token = response.data;

      var url = ContentStore.getConfig().sccUri + '/' + payment.token;

      var data = {
        processCardVerificationRequest: {
          cardVerificationRequestId: payment.token,
          cardNumber: payment.cardNumberDisplay,
          expirationDate:
            ('00' + payment.cardExpireMonth.value).slice(-2) + payment.cardExpireYear.value.toString().substring(2),
          cardholderName: payment.cardHolderName,
          verificationCode: payment.securityCodeValidation,
          secureKey: ContentStore.getConfig().sccHoneypotKey,
          street: payment.billingAddress.streetAddress,
          postalCode: payment.billingAddress.postalCode
        }
      };

      var config = { timeout: 10000 };

      return $http.put(url, data, config);
    });
  };
}

App.service('CheckoutService', ['$http', 'JobStore', 'ContentStore', '$q', CheckoutService]);
